import { lazyLoad } from 'utils/loadable';

export const ReferralPage = lazyLoad(
  () => import('./ReferralPage'),
  module => module.ReferralPage,
);
